/* unplugin-vue-components disabled */import { render } from "./edit-modal.vue?vue&type=template&id=9db752fc&scoped=true"
import script from "./edit-modal.vue?vue&type=script&lang=js"
export * from "./edit-modal.vue?vue&type=script&lang=js"

import "./edit-modal.vue?vue&type=style&index=0&id=9db752fc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db752fc"],['__file',"src/pages/sh-companies/edit-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9db752fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9db752fc', __exports__)) {
    api.reload('9db752fc', __exports__)
  }
  
  module.hot.accept("./edit-modal.vue?vue&type=template&id=9db752fc&scoped=true", () => {
    api.rerender('9db752fc', render)
  })

}


export default __exports__